import React from 'react';

const PromoIcon = ({ width = 20, height = 20, fill = '#CE181E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33398 18.3333L3.34232 1.66663H11.6673L16.6673 6.66663V18.3333H3.33398ZM10.834 2.91663V7.49996H15.4173L10.834 2.91663Z"
        fill={fill}
      />
    </svg>
  );
};

export default PromoIcon;
